import {Callout} from '@wandb/weave/components/Callout';
import {IconName} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {AddPanelsDrawerButton} from './AddPanelsDrawerButton';

// This message appears if the section has panels, but no data for those panels
// i.e. 0 active panels and >0 inactive panels
export const EmptySectionMessageNoMetrics = () => (
  <EmptyMessageGeneric
    header="No metrics logged yet."
    details="Charts will appear here as data is logged."
  />
);

// This message appears if the section has no panels at all
// i.e. 0 active panels and 0 inactive panels
export const EmptySectionMessageNoPanels = () => {
  return (
    <EmptyMessageGeneric
      header="No visualizations yet"
      details={
        <p className="hide-in-report">
          You can add panels from the section's overflow menu.
        </p>
      }
    />
  );
};

export const EmptyPanelBankMessage = () => {
  return (
    <EmptyMessageGeneric
      containerHeight="90%"
      header="No visualizations yet"
      details={
        <p className="w-[24rem] text-center">
          Use the “Add panels” button to quickly generate panels from available
          keys or build custom visualizations.
        </p>
      }
      actions={<AddPanelsDrawerButton />}
    />
  );
};

export const EmptyPanelSearchMessage = () => {
  return (
    <EmptyMessageGeneric
      containerHeight="90%"
      iconName="search"
      iconColor="moon"
      header="No panels found"
      details="Try another search."
    />
  );
};

// This is a generic message template that appears when
// the panel bank or a panel bank section is empty
const EmptyMessageGeneric = ({
  containerHeight = '100%',
  iconName = 'chart-vertical-bars',
  iconColor = 'teal',
  header,
  details,
  actions,
}: {
  containerHeight?: string;
  iconName?: IconName;
  iconColor?: 'teal' | 'moon';
  header: string;
  details: string | JSX.Element;
  actions?: JSX.Element;
}) => {
  return (
    <Tailwind style={{height: containerHeight}}>
      <div className="flex h-full flex-col items-center justify-center">
        <Callout
          className="mb-12"
          color={iconColor}
          icon={iconName}
          size="small"
        />
        <p className="mb-3 text-lg font-semibold">{header}</p>
        {typeof details === 'string' ? <p>{details}</p> : details}
        {actions != null && <div className="mt-16 flex gap-8">{actions}</div>}
      </div>
    </Tailwind>
  );
};
